export default {"src":"/_next/static/media/sprig.52ba3dcf.svg","height":150,"width":399,"blurWidth":0,"blurHeight":0};